import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { BsXCircle } from "react-icons/bs";
// import TextField from '@mui/material/TextField';
import MyButton from '../MyButton'
import Countdown from 'react-countdown';
import { BUY_TURN, SHOW_MSISDN, SHOW_OTP, SHOW_PACKAGE, SHOW_SUCCESS } from '../../common/constant';
import { customStyles, headerContainerStyle, iconStyle, titleStyle, textStyle } from '../../common/modalStyle'
import { useNavigate } from 'react-router-dom';
import { store } from '../..';
import { setDataFromModal, setDataToModal, setShowAuctionSubmitModal, setShowConfirmModal, setShowResultModal } from '../../actions/modal';
import TextField from '@mui/material/TextField';
import { eventAuctionSubmitBus } from '../../common/utils';
import { restPostApi } from '../../services/httpService';
import { auctionSubmitUrl } from '../../common/url';
import { error, httpSuccess, noTurnLeft, success } from '../../common/errorCode';
import { useSelector } from 'react-redux';

const MyAuctionSubmitModal = ({ isOpenOtp, setOpenOtp, errorMessage }) => {
    const tokenInfo = useSelector((state) => state.SessionReducer);
    // const [isBuyMoreTurn, setShowBuyMoreTurn] = React.useState(false);

    // console.log("INIT isBuyMoreTurn: " + isBuyMoreTurn);
    const navigate = useNavigate();
    const dataRef = useRef("");


    let timeField = <div></div>
    let textField = <div></div>

    function closeModal() {
        store.dispatch(setShowAuctionSubmitModal(false));
    }

    function submitAuctionClick() {
        console.log("dataRef.current: " + dataRef.current.value);
        // pass data to component
        // store.dispatch(setDataFromModal(dataRef.current.value));
        // eventAuctionSubmitBus.dispatch("auctionSubmit", { data: dataRef.current.value })
        submitAuction(dataRef.current.value);
    }

    async function submitAuction(data) {
        let res = await restPostApi(
            auctionSubmitUrl,
            {
                "value": data,
            },
            tokenInfo
        );
        console.log("res: " + JSON.stringify(res));

        if (res != null) {
            console.log("status: " + res.status);

            let errorCode = error;
            let message = "Success";
            if (res.status === httpSuccess) {
                console.log("errorCode: " + res.data.errorCode);
                errorCode = res.data.errorCode;
                let isShowBuyTurn = false;
                if (res.data.errorCode === success) {
                    // get requestId
                    message = res.data.message

                } else {
                    message = res.data.message
                    if (res.data.errorCode === noTurnLeft) {
                        console.log("show buy more turn");
                        isShowBuyTurn = true;
                    }
                }
                if (isShowBuyTurn) {
                    store.dispatch(setDataToModal({
                        type: 'confirm',
                        dataToModal: {
                            errorCode: res.data.errorCode,
                            message: message,
                            action: BUY_TURN
                        }
                    }));
                } else {
                    store.dispatch(setDataToModal({
                        type: 'result',
                        dataToModal: {
                            errorCode: res.data.errorCode,
                            message: message
                        }
                    }));
                }
            } else {
                console.log("message: " + res.data);
                message = res.data
                store.dispatch(setDataToModal({
                    type: 'result',
                    dataToModal: {
                        errorCode: res.data.errorCode,
                        message: message
                    }
                }));
            }
        } else {
            console.log("message: Exception");
            store.dispatch(setDataToModal({
                type: 'result',
                dataToModal: {
                    errorCode: error,
                    message: "Exception An error was happened !"
                }
            }));
        }
    }

    return (
        <div>
            <Modal
                isOpen={isOpenOtp}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Result Modal"
            >
                <div style={headerContainerStyle}>
                    <div style={iconStyle} onClick={closeModal}>
                        <BsXCircle style={{ height: "2rem", width: "2rem" }} />
                    </div>
                </div>
                <div style={titleStyle}>AUCTION SUBMITING</div>

                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <TextField id="standard-basic"
                        type='number'
                        inputProps={{ min: 0, style: { textAlign: 'center' } }}
                        inputRef={dataRef}
                        label="Your Auction" variant="standard" style={{ textAlign: "center", width: "70%" }} />
                </div>
                <div style={{
                    color: "black",
                    textAlign: "center",
                    marginTop: "20px"
                }}>
                    Example: 100 KIP
                </div>
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {textField}
                </div>
                {timeField}
                <div style={{ marginTop: "20px" }}>
                </div>

                <MyButton onClickButton={submitAuctionClick} />
                <div style={{ marginTop: "20px" }}>
                </div>
            </Modal>
        </div>
    );
}

export default MyAuctionSubmitModal;